export enum RegisterTypes {
  NORMAL = 'hi-normal',
  QUESTIONNAIRE = 'hi-questionnaire',
  NIPT = 'nipt',
  LAB_ADRIALAB = 'lab-adrialab',
  LAB_BIOLAB = 'lab-biolab',
}
